const breakpoints = {
  xs: '0px',
  sm: '320px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  xxl: '1440px',
  xxxl: '1666px',
};

export const MAIN_CONTAINER_SIZE = '948px';

export const MAIN_CONTAINER_SIZE_MEDIUM = '1072px';

export const MAIN_CONTAINER_SIZE_LARGE = '1187px';

export const CONTAINER_SIZE_LARGE = '1200px';

export const CONTENTFUL_COMMON_CONTAINER_SIZE = '1160px';

export const HANDOFF_CONTAINER_SIZE = '1920px';

// REMOVE_PADDING defines the amount of padding to remove from elements when calculating layout dimensions.
// This value should be updated whenever the global padding applied to the layout changes,(Container HOC)
// to ensure consistent spacing and alignment across the UI.
export const REMOVE_PADDING = '32px';

export default breakpoints;
